import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable} from 'rxjs';
import { BasicOfInventionDetailsService } from '../_services/basic-of-invention-details.service';
import { PatentDraftService } from './patent-draft.service';
import { PatentSearchService } from './patent-search.service';
import { UserDataService } from './user-data.service';

@Injectable({
    providedIn: 'root'
})

export class InventionResolver implements Resolve<any> {
    constructor(private basicOfInventionDetailsService: BasicOfInventionDetailsService,
        private patentDraftService: PatentDraftService,
        private patentSearchService: PatentSearchService,
        private userDataService: UserDataService, 
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        const id = route.paramMap.get('id');
        const path = route.routeConfig.path;

        if (path === 'basicInventionDetails/:id') {
            return this.basicOfInventionDetailsService.getBasicInventionDetailsByprojectId(+id)
        }

        if (path === 'patentDraft/:id') {
            return this.patentDraftService.getPatentDraftByProjectId(+id)
        }

        if (path === 'patentSearch/:id') {
            return this.patentSearchService.getPatenetSearchByProjectID(+id)
        }

        if (path === 'address/:id') {
            return this.userDataService.getUserDetailsByuserId(+id)
        }
    }
}
